import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"
import { filtersService } from "./filters"

const buildFilterUrl = (endpoint) =>
  `${API_ROUTES.BOOK.BASE}${API_ROUTES.BOOK.FILTER}/${endpoint ? endpoint : ""}`

export const filterService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAviaFilterData: builder.query({
      query: (arg) => ({
        url: buildFilterUrl("transport?format=json"),
        method: "GET",
      }),
      providesTags: [],
      // async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      //   try {
      //     const { data } = await queryFulfilled
      //     const { default_departure } = data || {}

      //     if (!default_departure) return

      //     const { ids, is_local } = default_departure
      //     if (!ids?.length) return

      //     dispatch(
      //       filtersService.endpoints.getTerminals.initiate({
      //         ids,
      //         isLocal: is_local,
      //         local: arg.local,
      //       })
      //     )
      //   } catch (err) {
      //     console.error("get terminals err", err)
      //   }
      // },
    }),
  }),
})

export const { useGetAviaFilterDataQuery, useLazyGetAviaFilterDataQuery } = filterService
